
export default {
    name: '',

    props: {},
}
